import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import * as _ from 'lodash';
import { AngularFireDatabase } from 'angularfire2/database';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  // public title: object = { p0: '協會宗旨', p1: '組織架構', p2: '協會章程', p3: '志工招募', p4: '顧問醫師' };
  // public titleIndex: string = 'p0';
  public content = '';

  constructor(
    public router: Router,
    private titleService: Title,
    private metaService: Meta,
    public db: AngularFireDatabase
  ) {
    this.titleService.setTitle('社團法人台灣腸治久安協會-成立宗旨');
    this.metaService.updateTag({ name: 'description', content: '' });
    this.metaService.updateTag({ property: 'og:title', content: '社團法人台灣腸治久安協會-成立宗旨' });
    this.metaService.updateTag({ property: 'og:description', content: '' });

  }

  ngOnInit() {
    this.db.list('/tw/article/about/').$ref.once('value').then(s => {
      this.content = s.val().content;
    });
    this.gototop();

  }
  gototop() {
    $('html,body').animate({ scrollTop: 0 }, 'slow');   /* 返回到最頂上 */
  }

}



// WEBPACK FOOTER //
// ./src/app/tw/about/about.component.ts